import {
  BASE_WORKER_REQUIREMENTS,
  type BaseWorkerRequirements,
  MSW_WORKER_REQUIREMENTS,
  type MswWorkerRequirements,
  NON_PT_WORKER_REQUIREMENTS,
  type NonPtWorkerRequirements,
  OT_WORKER_REQUIREMENTS,
  type OtWorkerRequirements,
  PT_WORKER_REQUIREMENTS,
  type PtWorkerRequirements,
  type WorkerRequirements,
} from "@src/appV2/ExperimentalHomeHealth/Cases/types";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export interface HomeHealthQualificationGroups {
  nonPt: NonPtWorkerRequirements[] | BaseWorkerRequirements[];
  pt: PtWorkerRequirements[];
  ot: OtWorkerRequirements[];
  msw: MswWorkerRequirements[];
  allAvailableQualifications: WorkerRequirements[];
}

export function useHomeHealthQualificationGroups(): HomeHealthQualificationGroups {
  const isPtEnabled = useCbhFlag(CbhFeatureFlag.HOME_HEALTH_PT_ENABLED, {
    defaultValue: false,
  });
  const isOtEnabled = useCbhFlag(CbhFeatureFlag.HOME_HEALTH_OCCUPATIONAL_THERAPIST_ENABLED, {
    defaultValue: false,
  });
  const isMswEnabled = useCbhFlag(CbhFeatureFlag.HOME_HEALTH_SOCIAL_WORKER_ENABLED, {
    defaultValue: false,
  });
  const enableUnskilledQualifications = useCbhFlag(
    CbhFeatureFlag.HH_ENABLE_UNSKILLED_QUALIFICATIONS,
    { defaultValue: false }
  );
  const chhaRegistryConfig = useCbhFlag(CbhFeatureFlag.CHHA_REGISTRY_CONFIG, {
    defaultValue: { chhaStatus: "certificate" },
  });

  const nonPt =
    enableUnskilledQualifications && chhaRegistryConfig.chhaStatus === "unavailable"
      ? BASE_WORKER_REQUIREMENTS
      : NON_PT_WORKER_REQUIREMENTS;
  const pt = isPtEnabled ? PT_WORKER_REQUIREMENTS : [];
  const ot = isOtEnabled ? OT_WORKER_REQUIREMENTS : [];
  const msw = isMswEnabled ? MSW_WORKER_REQUIREMENTS : [];

  return {
    nonPt,
    pt,
    ot,
    msw,
    allAvailableQualifications: [...nonPt, ...pt, ...ot, ...msw],
  };
}
